import { createFileRoute } from '@tanstack/react-router'
import { EditEmployeeDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import EditEmployeeDialog from '@/routes/_app/-dialogs/edit-employee'

export const Route = createFileRoute('/@modal/employees/$employeeId/edit')({
  params: idParams('employeeId'),
  staticData: { slotScope: '/_app' },
  pendingComponent: EditEmployeeDialogPending,
  component: EditEmployeeSlot,
})

function EditEmployeeSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <EditEmployeeDialog employeeId={Number(params.employeeId)} {...slot} />
}
